/**
 * Returns the available platforms in the system.
 *
 * @returns {{ key: string, label: string }} The platform's key and label
 */
export default function getPlatforms() {
    return [{ key: 'platform__v', label: 'All Vaults', canViewAggregatedPlatformData: true }];
}
